import {AbstractControl, ValidationErrors} from "@angular/forms";
import {Observable} from "rxjs/Observable";
import {of} from "rxjs";

export class AuthorizationComposerValidator {
  constructor(private validationCallback: () => boolean) {
  }

  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    return this.validationCallback() ? of(null) : of({error: true});
  }

  registerOnValidatorChange?(fn: () => void): void {
    throw new Error('Method not implemented.');
  }
}
